import { render, staticRenderFns } from "./BarcodeModal.vue?vue&type=template&id=560f5512&scoped=true&"
import script from "./BarcodeModal.vue?vue&type=script&lang=js&"
export * from "./BarcodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f5512",
  null
  
)

export default component.exports